import React, { useEffect, useState } from 'react';
import {
	Button,
	Table,
	Form,
	Modal,
} from "react-bootstrap";

const PopupMessageView = (opt) => {
	const [messageData, setMessageData] = useState(opt.data || {});

	useEffect(() => {
		if (opt.data) {
			setMessageData(opt.data);
		}
	}, [opt.data]);

	const selfClose = function() {
		opt.close(false);
	};

	return (
		<Modal show={opt.isShow} onHide={selfClose} centered size="lg">
			<Modal.Header closeButton>
				<Modal.Title>메시지 내용</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="table__view">
					<Table bordered responsive className="table__view">
						<tbody>
							<tr>
								<th scope='row'>제목</th>
								<td className="text-start">
									<Form.Control 
										name="title" 
										id="title" 
										value={messageData.emTitle || messageData.title || ""} 
										readOnly
									/>
								</td>
							</tr>
							<tr>
								<th scope='row'>내용</th>
								<td className="text-start">
									<Form.Control 
										as="textarea" 
										name="contents" 
										id="contents" 
										rows={10}
										value={messageData.contents || ""} 
										readOnly
									/>
								</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={() => selfClose()}>닫기</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PopupMessageView;